module.exports = __webpack_public_path__ + "static/media/halloween.5dfaff55.png";